module.exports = __webpack_public_path__ + "23ec4ba2104dd55b2597bd1c3cb1c9f0.svg";